import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireObject, AngularFireList, DatabaseReference } from 'angularfire2/database';
import { UtilityService } from './utility.service';
import { Constants } from '../config/Constants';
import { MenuItems } from '../../core/models/menu-items'
import { promise } from 'selenium-webdriver';
@Injectable()
export class MenuItemService {

  constructor(private db: AngularFireDatabase, private utilityService: UtilityService) {
  }

  addEventMenuItems(menuItems: MenuItems[], eventId: string): Promise<any> {
    if (this.utilityService.isLogged()) {
      return this.db.object(Constants.EVENT_URL + '/' + eventId + '/' + Constants.EVENT_MENU_ITEMS).set(menuItems);
    }
  }

  getEventMenuItems(eventId: string): AngularFireList<MenuItems> {
    console.log(Constants.EVENT_URL + '/' + eventId + Constants.EVENT_MENU_ITEMS);
    if (this.utilityService.isLogged()) {
      return this.db.list(Constants.EVENT_URL + '/' + eventId + Constants.EVENT_MENU_ITEMS);
    }
    return null;
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/services/menu-item.service.ts